<template>
  <button
    :class="{ active: active }"
    class="apartment-add-to-selected-btn heart"
    type="button"
    @click="$emit('toggle-favorite')"
  >
    <IconBase height="16" width="16">
      <Heart />
    </IconBase>
    <IconBase class="bordered-heart" height="16" width="16">
      <BorderedHeart />
    </IconBase>
  </button>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import Heart from '@/components/icons/Heart'
import BorderedHeart from '@/components/icons/BorderedHeart'

export default {
  name: 'AddToSelectedBtn',
  props: {
    active: Boolean,
  },
  components: {
    IconBase,
    Heart,
    BorderedHeart,
  },
  data() {
    return {
      selectedActive: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.apartment-add-to-selected-btn.heart {
  position: relative;

  .bordered-heart {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 2;

    svg {
      fill: #b5c9d4;
    }
  }

  &.active {
    .bordered-heart {
      display: none;
    }
  }
}
</style>
